import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { swalSureLogout } from '../../functions/swalOptions'
import { logout } from '../../store/slices/authSlice'
import { store, type RootState } from '../../store/store'
import { removeNotifyByDeviceToken } from '../../functions/shared/notify-helpers/removeNotify'
import { useAppSelector } from '../../hooks/redux'
import { getAdminRole } from '../../config/adminRoles'

const links = [
    { to: '/landlord/my_units/statistics', label: 'Statistics' },
    { to: '/landlord/sponsored_partners', label: 'Sponsored Partners' },
    { to: '/landlord/insider', label: 'BSO Insider' },
    { to: '/landlord/my_units', label: 'My Units' },
    { to: `/landlord/set_unit_modal/set_unit_modal/-/-`, label: 'Add Unit' },
    { to: '/landlord/events_safe', label: 'Events' },
    { to: '/landlord/schedule', label: 'Schedule' },
    { to: '/landlord/landlord_service_orders', label: 'Landlords / Orders' },
    { to: '/landlord/chats?mode=admin', label: 'Chats' },
]

const logoutHandler = (navigate: any): any => {
    void swalSureLogout().then(async (result: any) => {
        if (result.isDenied === true) {
            //  const clearDevice = await dispatch(clearDeviceToken())
            //  if (clearDevice.success === true && clearDevice.response != null) {
            store.dispatch(logout())
            // void removeNotifyByDeviceToken({
            //     userID: store.getState().user.currentUser.id as number,
            //     deviceToken: store.getState().user.currentUser.DeviceToken as string,
            //     badges: 0
            // })
            location.reload()
            navigate('/auth/login')
            //  }
        }
    })
}
const Sidebar = (): JSX.Element => {

    const navigate = useNavigate()
    const currentUser = useAppSelector((state: RootState) => state.user.currentUser as { email?: string })
    const role = getAdminRole(currentUser)
    const visibleLinks = role === 'marketing'
        ? links.filter((link) => link.to === '/landlord/sponsored_partners' || link.to === '/landlord/insider')
        : role === 'administration'
            ? [{ to: '/landlord/key-viewings', label: 'Key viewings archive' }]
            : [...links.filter((link) => link.to !== '/landlord/sponsored_partners' && link.to !== '/landlord/insider'), { to: '/landlord/key-viewings', label: 'Key viewings archive' }, { to: '/landlord/broker-analytics', label: 'Broker analytics' }]

    return (
        <div className="app-shell__sidebar-card card shadow-sm border-0">
            <div className="card-body p-4">
                <div className="d-flex align-items-center mb-4">
                    <div className="symbol symbol-40px symbol-circle bg-light-warning me-3">
                        <span className="symbol-label fw-bold text-dark">BSO</span>
                    </div>
                    <div>
                        <div className="fw-bold text-dark">BSO Admin</div>
                        <div className="text-muted fs-8">Navigation</div>
                    </div>
                </div>
                <div className="d-flex flex-column gap-2">
                    {visibleLinks.map((link) => (
                        <NavLink
                            key={link.to}
                            to={link.to}
                            className={({ isActive }) =>
                                `app-shell__nav-link d-flex align-items-center py-2 px-3 rounded ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="flex-grow-1">{link.label}</span>
                        </NavLink>
                    ))}
                    <div

                        key={'Logout'}

                        className={`text-decoration-none d-flex align-items-center py-2 px-3 rounded cursor-pointer`}
                    >
                        <span onClick={() => logoutHandler(navigate)} className="flex-grow-1">{'Logout'}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar
